// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"147":"118919c0ed112ddeb0a4","666":"e776f7e64bda1afe60e1","786":"15bc8060e18bf4912a4b","863":"9d6ee7836526de9b77ba"}[chunkId] + ".js";
};